import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import "./markdown-renderer.css";

const MedicalReport = ({ content, SummaryData }) => {
   const [fade, setFade] = useState(false);

   useEffect(() => {
      if (SummaryData?.status === "updating") {
         const timer = setTimeout(() => {
            setFade(true);
         }, 1000);

         return () => clearTimeout(timer);
      } else {
         setFade(false);
      }
   }, [SummaryData?.status]);

   if (!content) return null;

   return (
      <div className={`${fade ? "fade-out fade-out-opacity" : ""}`} style={{ fontSize: "17px", paddingRight: "20px" }}>
         {!content?.includes("###") ? (
            <pre
               style={{
                  whiteSpace: "pre-wrap",
                  fontFamily: "inherit",
                  fontSize: "17px",
               }}
            >
               {content}
            </pre>
         ) : (
            <div className="medical-report-markdown">
               <ReactMarkdown source={content} />
            </div>
         )}
      </div>
   );
};

export default MedicalReport;
